// @ vendors
const { Promise } = require('es6-promise');
// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const {
    MORTGAGE_REQUEST_FETCH_EXPENSES_PROVISION_REQUEST,
    MORTGAGE_REQUEST_FETCH_EXPENSES_PROVISION_SUCCESS,
    MORTGAGE_REQUEST_FETCH_EXPENSES_PROVISION_FAILURE,
    MORTGAGE_REQUEST_EXPENSES_PROVISION_SET_FIELD
} = require('constants/actionTypes');

const requestExpensesProvisionInProgress = () => ({
    type: MORTGAGE_REQUEST_FETCH_EXPENSES_PROVISION_REQUEST
});

const requestExpensesProvisionSuccess = (data) => ({
    type: MORTGAGE_REQUEST_FETCH_EXPENSES_PROVISION_SUCCESS,
    data: data
});

const requestExpensesProvisionFailure = (error) => ({
    type: MORTGAGE_REQUEST_FETCH_EXPENSES_PROVISION_FAILURE,
    data: {
        error
    }
});

const requestExpensesProvision = () => (dispatch, getState) => {
    const currentState = getState().mortgageRequestExpensesProvision;
    const isAlreadyFetching = currentState.get('isFetching');

    if (!isAlreadyFetching) {
        dispatch(requestExpensesProvisionInProgress());

        return APIGet({
            dispatch,
            endpoint: 'mortgageRequestExpensesProvision'
        })
        .then(response => dispatch(requestExpensesProvisionSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(requestExpensesProvisionFailure(response.error))
            } else {
                throw response;
            }
        });
    } else {
        return Promise.resolve()
    }
};

const setField = (inputField, data) => ({
    type: MORTGAGE_REQUEST_EXPENSES_PROVISION_SET_FIELD,
    payload: {
        inputField,
        data
    }
});

module.exports = {
    requestExpensesProvision,
    setField
};
